<div class="w-full flex justify-start items-center py-4 px-7">
    <i class="ico-Close cursor-pointer text-xl ml-3" (click)="dialogRef.close()"></i>
    <h3 class="text-lg">
        قوانین لغو رزرو
        (
        <ng-container [ngSwitch]="cancellationPlan">
            <ng-container *ngSwitchCase="cancellationPlanEnum.Easy">سهل گیرانه</ng-container>
            <ng-container *ngSwitchCase="cancellationPlanEnum.Normal">متعادل</ng-container>
            <ng-container *ngSwitchCase="cancellationPlanEnum.Hard">سختگیرانه</ng-container>
        </ng-container>
        )
    </h3>
</div>

<div class="py-4 overflow-y-auto">
    <div class="grid grid-cols-2 gap-4 relative mx-7 pb-2">

        <div *ngFor="let tab of tabs; let index = index" class="text-center cursor-pointer text-black-300"
            (click)="onTabClicked(index)">
            {{tab}}
        </div>

        <div class="absolute h-[2px] bg-blue-500 bottom-0 transition-all"
            [ngStyle]="{ 'width': (100 / (tabs.length) ) + '%', 'right' : ( calculatedRightNavigator + '%')  }"></div>

    </div>

    <ng-container
        *ngTemplateOutlet="conditions; context:{ data: activatedTab == 1 ? dto.normalDayDto : dto.peakDayDto }"></ng-container>

    <ng-template #conditions let-data="data">
        <div class="bg-metal-50 p-4">

            <mat-accordion [multi]="true" class="!px-0 !mt-0" hideToggle>
                <div class="ecolodge-policies-accordion !text-black w-full flex flex-col !p-0 !m-0">
                    <mat-expansion-panel *ngFor="let day of data" #faqPanel class="!mb-4">
                        <mat-expansion-panel-header class="!px-4 !py-4 bg-white">
                            <div class="flex justify-between items-center w-full">
                                <div class="flex justify-center items-center">
                                    <mat-panel-title>
                                        <h3 class="text-black-900 text-sm lg:text-base font-normal">
                                            {{ day.title }}
                                        </h3>
                                    </mat-panel-title>
                                </div>
                                <div class="flex justify-center items-center text-black-200">
                                    <div *ngIf="!faqPanel.expanded">
                                        <i class="text-3xl ico-Down"></i>
                                    </div>
                                    <div *ngIf="faqPanel.expanded">
                                        <i class="text-3xl ico-Up"></i>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel-header>
                        <div [@expandAccordionPanel]="faqPanel.expanded ? 'visible' : 'hidden'"
                            class="text-right p-3 text-black-300 bg-white">
                            <ng-container *ngFor="let condition of day.conditions; let index = index">
                                <h5 class="font-medium text-black-500">{{condition.title}}</h5>
                                <p class="text-black-300 font-normal mt-1">{{condition.description}}</p>

                                <div *ngIf="index < day.conditions.length - 1 "
                                    class="h-[1px] w-full bg-gray-2j00 my-3"></div>
                            </ng-container>
                        </div>
                    </mat-expansion-panel>
                </div>

            </mat-accordion>

        </div>
    </ng-template>
</div>